<template>
  <div>
    <common-dialog
      ref="dialog"
      width="600px"
      show-save-button
      edit-title
      unit="学生纪律量化登记"
      id-key="DisciplineRecordId"
      :data="data"
      form-label-width="85px"
      :form-rules="rules"
      :save-func="api.save"
      :get-data-func="api.info"
      @edit-opened="onEditOpened"
      @create-opened="onCreateOpened"
      :before-save="onBeforeSave"
      @close-saved="$emit('close-saved')"
      @closed="onClosed"
    >
      <template slot="form">
        <el-row>
          <el-col :span="isMB?24:12">
            <el-form-item label="姓名">
              {{data.FullName}}
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="年级">
              {{data.Grade}}
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="班级">
              {{data.Class}}
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="宿舍号">
              {{data.Dormitory}}
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="违规时间" prop="RecordTime">
              <!-- <el-date-picker type="datetime" v-model="data.RecordTime" disabled @change="getPoint" placeholder="请选择日期" format="yyyy-MM-dd HH:mm" 
                  value-format="yyyy-MM-dd HH:mm:ss" /> -->
                  {{data.RecordTime}}
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="扣分人">
              {{data.AddTeacherName}}
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="一级类别" class="is-required">
              <!-- <tree-select
                ref="treeSelect"
                style="width:100%;"
                :props="props"
                :options="TreeData"
                :value="data.DisciplineTypeId"
                :clearable="true"
                :accordion="true"
                :parentSelect="false"
                placeholder="请选择类别"
                @node-select="onTreeSelect($event)"
              /> -->
              <el-select v-model="data.Pid" @change="pChange" disabled placeholder="请选择一级类别">
                <el-option v-for="p in plist" :key="p.DisciplineTypeId" :value="p.DisciplineTypeId" :label="p.DisciplineTypeName" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="二级类别" prop="DisciplineTypeId">
              <el-select v-model="data.DisciplineTypeId" @change="disChange" disabled placeholder="请选择二级类别">
                <el-option v-for="s in slist" :key="s.DisciplineTypeId" :value="s.DisciplineTypeId" :label="s.DisciplineTypeName" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="违规扣分" prop="Point">
              <!-- <el-input type="number" v-model="data.Point" @blur="checkNum" placeholder="请填写扣分值"></el-input> -->
              {{data.Point}}
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注" prop="Remark">
              <el-input size="mini" type="textarea" style="width:100%" v-model="data.Remark" placeholder="请输入备注"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="附件">
              <import-file
                v-if="show"
                :upload-url="api.UploadFileUrl"
                :subData="{}"
                text="上传附件"
                w="80px"
                :btntype="true"
                single
                @on-uploaded="uploaded($event)"
                @on-remove="removed($event)"
                :uploadFiles="data.uploadedFiles"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import importFile from "@/components/common/files/importFile";
import treeSelect from "@/components/common/treeSelect";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    importFile,
    treeSelect
  },
  computed: {
    plist() {
      return this.disList.filter(x => x.Lv == 1);
    },
    slist() {
      return this.disList.filter(x => x.Pid == this.data.Pid);
    },
  },
  data() {
    return {
      api: require("@/api/attendance/disrecord").default,
      strApi: require("@/api/attendance/strict").default,
      disApi: require("@/api/attendance/disciplinetype").default,
      data: {
        DisciplineRecordId: 0,
        TermId: 0,
        FullName: "",
        StudentId: 0,
        DisciplineTypeId: 0,
        DisciplineTypeName: "",
        StrictControlId: 0,
        Point: 0,
        Pid: null,
        // RecordDate: "",
        RecordTime: "",
        Remark: "",
        FileUrl: "",
        AddTeacherId: 0,
        uploadedFiles: [],
        Grade: "",
        Class: "",
        Dormitory: "",
        AddTeacherName: "",
      },
      // props: {
      //   value: "DisciplineTypeId",
      //   label: "DisciplineTypeName",
      //   children: "children",
      // },
      // TreeData: [],
      show: false,
      disList: [],
      isMB: this.$store.state.isMB,
      rules: {
        DisciplineTypeId: [{ required: true, message: "请选择二级类别" }],
        RecordTime: [{ required: true, message: "违规时间不能为空" }],
        Point: [{ required: true, message: "扣分值需大于0" }],
      },
    };
  },
  methods: {
    onCreateOpened(data) {
      
    },
    onEditOpened(data) {
      this.show = true;
      this.loading(true);
      this.disApi.list({ Status: 1 }).then(res => {
        this.loading(false);
        this.disList = res.Data;
        // this.TreeData = this.$commonJs.toTreeData(res.Data, "DisciplineTypeId");
        var obj = res.Data.find(x => x.DisciplineTypeId == data.DisciplineTypeId);
        this.data.Pid = obj.Pid;
      });
      if(data.FileUrl) {
        this.data.uploadedFiles = [{ name: "附件."+ data.FileUrl.split(".")[1], url: '/api' + data.FileUrl }];
      }
    },
    // onTreeSelect(t) {
    //   if(t) {
    //     this.data.DisciplineTypeId = t.DisciplineTypeId;
    //     this.data.DisciplineTypeName = t.DisciplineTypeName;
    //     this.data.Point = t.Point;
    //     this.getPoint();
    //   } else {
    //     this.data.DisciplineTypeId = null;
    //     this.data.DisciplineTypeName = "";
    //   }
    // },
    pChange(v) {
      this.data.DisciplineTypeId = null;
      this.data.DisciplineTypeName = null;
    },
    disChange(v) {
      var obj = this.slist.find(x => x.DisciplineTypeId == v);
      this.data.DisciplineTypeName = obj.DisciplineTypeName;
      this.getPoint();
    },
    getPoint() {
      if(this.data.RecordTime && this.data.DisciplineTypeId) {
        this.strApi.getPoint({ disciplineTypeId: this.data.DisciplineTypeId, time: this.data.RecordTime }).then(res => {
          if(res.Code==0) {
            this.data.Point = res.Data;
          }
        })
      }
    },
    checkNum() {
      if(this.data.Point > 0) {
        this.data.Point = Number(this.data.Point);
      } else {
        this.data.Point = null;
      }
    },
    uploaded(res) {
      // this.data.FileName = res.Data.FileName + "." + res.Data.Extension;
      if(res.Data) {
        this.data.FileUrl = res.Data.VirtualPath;
        // item.uploadedFiles = [{ name: res.Data.FileName+ "." +res.Data.Extension, url: '/api' + res.Data.VirtualPath }];
      }
    },
    removed(res) {
      this.data.FileUrl = "";
      this.data.uploadedFiles = [];
    },
    onBeforeSave() {
      
    },
    onClosed() {
      this.show = false;
    },
  },
};
</script>
<style lang="scss">
</style>